import { useEffect, useRef, useState } from 'react';

import {db, storage} from '../firebase'

import { addData, getData, getDocDataOnCondition, getDocOnCondition, handleFireBaseUpload, updateDoc } from '../Firebase/firestore';

// const db = firebase.firestore()
// const storage = firebase.storage()

function Fabric({edit, setEdit}) {
  const formatOptionLabel = (value) =>
    value
      ? value
          .toString()
          .split(" ")
          .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
          .join(" ")
      : "";

  const fabricName = useRef()
  // const brand = useRef()
  const color = useRef()
  const colorCode = useRef()
  // const fabricType = useRef()
  const material = useRef()
  const des = useRef()
  const width = useRef()
  const weight = useRef()
  const link =  useRef()
  const stock = useRef()
  
  // const [pattern , setPattern] = useState(["Stipped", "Plain", "Checks", "Block"])

  const [otherImgs, setOtherImg] = useState()
  const [imgFile, setimgFile] = useState()
  
  const [preview, setPreview] = useState()
  const [otherPreview, setOtherImgPreview] = useState()

  const [status, updateStatus] = useState()

  const [enable, setEnable] = useState(1)

  const [Brands, setBrands] = useState([])
  const [brandValue, setBrandValue] = useState("")
  const [brandDropdownOpen, setBrandDropdownOpen] = useState(false)
  const brandDropdownRef = useRef(null)
  const [weaveOptions, setWeaveOptions] = useState(["plain", "twill", "haring bon"])
  const [weaveValue, setWeaveValue] = useState("plain")
  const [weaveDropdownOpen, setWeaveDropdownOpen] = useState(false)
  const weaveDropdownRef = useRef(null)
  const [patternOptions, setPatternOptions] = useState(["plain", "checks", "floral", "lining"])
  const [patternValue, setPatternValue] = useState("plain")
  const [patternDropdownOpen, setPatternDropdownOpen] = useState(false)
  const patternDropdownRef = useRef(null)
  const [widthOptions, setWidthOptions] = useState(["36 inch", "58 inch"])
  const [widthValue, setWidthValue] = useState("36 inch")
  const [widthDropdownOpen, setWidthDropdownOpen] = useState(false)
  const widthDropdownRef = useRef(null)
  const [optionModal, setOptionModal] = useState({ open: false, label: "", value: "" })

  const [compositionOptions, setCompositionOptions] = useState(["Cotton", "Wool", "Polyester", "Viscose"])
  const [composition, setComposition] = useState([])

  const [oca, setOca] = useState( ["party", "casual", "formal"] )

  
  useEffect(()=>{
    if(edit){
      console.log("Edit :", edit)
      if(edit["brand"]){
        setBrandValue(edit["brand"])
      }
      if(edit["weave"]){
        setWeaveValue(edit["weave"])
      }
      if(edit["pattern"]){
        setPatternValue(edit["pattern"])
      }
      if(edit["width"]){
        setWidthValue(edit["width"])
      }
      setComposition([]);
      setCompositionOptions(["Cotton", "Wool", "Polyester", "Viscose"]);
    }
    const collection = db.collection("Brands")
    getData(collection).then((data)=>{
      setBrands(data)
      if(!edit && data && data.length > 0){
        setBrandValue(data[0].name)
      }
    })
    
  }, [])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (brandDropdownRef.current && !brandDropdownRef.current.contains(event.target)) {
        setBrandDropdownOpen(false)
      }
      if (weaveDropdownRef.current && !weaveDropdownRef.current.contains(event.target)) {
        setWeaveDropdownOpen(false)
      }
      if (patternDropdownRef.current && !patternDropdownRef.current.contains(event.target)) {
        setPatternDropdownOpen(false)
      }
      if (widthDropdownRef.current && !widthDropdownRef.current.contains(event.target)) {
        setWidthDropdownOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])
  useEffect(()=>{
    if (!imgFile) {
      setPreview(undefined)
      return
  }
      const objectUrl = URL.createObjectURL(imgFile)
      setPreview(objectUrl)

      // free memory when ever this component is unmounted
      return () => URL.revokeObjectURL(objectUrl)
  }, [imgFile])
  
  useEffect(()=>{
      if (!otherImgs) {
        setOtherImgPreview(undefined)
        return
      }
      let arr = []
      for(let i=0;i<otherImgs.length;i++){
        arr.push(URL.createObjectURL(otherImgs[i]))
      }
      
      setOtherImgPreview(arr)

      // free memory when ever this component is unmounted
      return () => arr
  }, [otherImgs])

  const uploadMultipleFiles = async(arr, ref)=>{
    let data = []
    
    
    for(let i=0;i<arr.length;i++){
        const item = arr[i]
        const name = item && item.name ? item.name.replace("`", "") : ""
        if(item && typeof item === "object" && name){
          data.push(await handleFireBaseUpload(name+"-"+(new Date().getTime()).toString(), item, ref))
        } else {
          data.push(item)
        }
        
    }
    
    return data
  }
  
  const updateSuits = async(id, src)=>{
    try{  
      const typ = ["Coat", "Pant", "Shirt", "Vest"]
      
      for(let i=0;i<typ.length;i++){
        
        const coll = db.collection("Fabric").doc("Suits").collection(typ[i])
        const data = await getDocDataOnCondition(coll, "fabricID",id )

        for(let i=0;i<data.length;i++){
          await updateDoc(coll, data[i].id, {...data[i].data, ...{"fabricImg":src}})
        }
      }
      console.log("Done with updating all the suit docs")

    }catch(e){

    }
  }
  
  const [selectedValue, setSelectedValue] = useState("Suiting");
  
  const submitFabric = async()=>{
    const brand = brandValue
    const ocas = ""
    const pattern = patternValue
    const weave = weaveValue
    const width = widthValue

    

    // console.log("this is radio", document.getElementById("flexRadioDefault1").checked, )

    if( ( (edit && edit.type === 1 && (!edit.name && !fabricName.current.value) ) || ( !edit && !fabricName.current.value) )  ||
    ( (edit && edit.type === 1 && (!edit.brand && !brand)) || ( !edit && !brand)) ||
( (edit && edit.type === 1 && (!edit.color &&  !color.current.value)) || ( !edit && !color.current.value)) ||
( (edit && edit.type === 1 && (!edit.src && !imgFile)) || ( !edit && !imgFile)) ||
( (edit && edit.type === 1 && (!edit.colorCode &&  !colorCode.current.value)) || ( !edit && !colorCode.current.value)) ||
( (edit && edit.type === 1 && (!edit.des  && !des.current.value)) || ( !edit && !des.current.value)) ||
( (edit && edit.type === 1 && (!edit.single  && !otherImgs)) || ( !edit && !otherImgs))


// ( (edit && edit.type === 1 && (!edit.weave  && !weave.current.value)) || ( !edit && !weave.current.value)) ||
// ( (edit && edit.type === 1 && (!edit.weight  && !weight.current.value)) || ( !edit && !weight.current.value)) ||
// ( (edit && edit.type === 1 && (!edit.pattern  && !pattern.current.value)) || ( !edit && !pattern.current.value)) ||
// ( (edit && edit.type === 1 && (!edit.width  && !width.current.value)) || ( !edit && !width.current.value)) 

    ){
      setEnable(1)
      console.log("edit: ", edit)
//       console.log("This is the scene",  
//         ( (edit && edit.type === 1 && (!edit.name && !fabricName.current.value) ) || ( !edit && !fabricName.current.value) )  ,
//     ( (edit && edit.type === 1 && (!edit.brand && !brand.current.value)) || ( !edit && !brand.current.value)) ,
// ( (edit && edit.type === 1 && (!edit.color &&  !color.current.value)) || ( !edit && !color.current.value)) ,
// ( (edit && edit.type === 1 && (!edit.src && !imgFile)) || ( !edit && !imgFile)) ,
// ( (edit && edit.type === 1 && (!edit.colorCode &&  !colorCode.current.value)) || ( !edit && !colorCode.current.value)) ,
// ( (edit && edit.type === 1 && (!edit.material &&  !material.current.value)) || ( !edit && !material.current.value)) ,
// ( (edit && edit.type === 1 && (!edit.des  && !des.current.value)) || ( !edit && !des.current.value)) ,
// ( (edit && edit.type === 1 && (!edit.single  && !otherImgs)) || ( !edit && !otherImgs))
// ( (edit && edit.type === 1 && (!edit.weave  && !weave.current.value)) || ( !edit && !weave.current.value))
// ( (edit && edit.type === 1 && (!edit.weight  && !weight.current.value)) || ( !edit && !weight.current.value))
// ( (edit && edit.type === 1 && (!edit.pattern  && !pattern.current.value)) || ( !edit && !pattern.current.value))
// ( (edit && edit.type === 1 && (!edit.width  && !width.current.value)) || ( !edit && !width.current.value))
//       )
      updateStatus("Please add all the Details")
    }else{
      setEnable(0)
      
      const collection = db.collection('Fabric').doc('Suits').collection('fabrics')
      
      const name = fabricName.current.value + brand +"-"+(new Date().getTime()).toString()
      
      let ref = `Fabrics/${fabricName.current.value}_${brand.replace("`", "")}`
      updateStatus("Uploading Fabric Images...")
      let arr = []
      let arr1 = []
      if(imgFile){
        arr = [imgFile]
      }
      if(!imgFile){
        console.log("img file not selected")
        arr = [edit.src]
      }
      if(otherImgs && otherImgs.length > 0){
        arr1 = [...otherImgs]
      }
      const otherImagesData = await uploadMultipleFiles([...arr, ...arr1], ref)
      

      
      var brandImg = ""

      for(var i = 0;i<Brands.length;i++){
        if(Brands[i].name === brand){
          brandImg = Brands[i].src
        }
      }
      // console.log(otherImgs.length, otherImagesData.slice(1))
      const Data = {
            "id" : (edit && edit.id) ? edit.id : (new Date()).getTime().toString(),

            "src": otherImagesData && otherImagesData.length > 0 ? otherImagesData[0] : edit.src,  
            "name": fabricName.current.value ? fabricName.current.value :  edit.name,
            "brand" : brand? brand : edit.brand,
            "brandImg" : brandImg ?  brandImg : edit.brandImg ,
            "color" : color.current.value?  color.current.value.toString().split(",").map(s => s.trim()) : edit.color,

            "colorCode": colorCode.current.value ? colorCode.current.value.toString().split(",").map(s => s.trim()) : edit.colorCode,
            "des":  des.current.value ? des.current.value : edit.des,

            "material":  compositionString ? compositionString : (material.current && material.current.value) ? material.current.value : (edit && edit.type === 1 && edit.material) ? edit.material : "",

            "composition": composition.length > 0
              ? composition.map((c) => ({ name: c.name, percent: Number(c.percent) || 0 }))
              : (edit && edit.type === 1 && Array.isArray(edit.composition)) ? edit.composition : [],

            "single": otherImgs && otherImgs.length > 0 ? otherImagesData.slice(1) : edit.single ,

            "pattern":  pattern ? pattern : (edit && edit.type === 1 && edit.pattern) ? edit.pattern : "",

            "weave" : weave ? weave : (edit && edit.type === 1 && edit.weave) ? edit.weave : "",
            "weight" : weight.current.value ? weight.current.value : (edit && edit.type === 1 && edit.weight) ? edit.weight :  "" ,
            "width" : width ? width : (edit && edit.type === 1 && edit.width) ? edit.width :  "",
            "link" : link.current.value ? link.current.value : (edit && edit.type === 1 && edit.link) ? edit.link :  "",

            "stock" : (edit && edit.type === 1 && edit.stock) ? edit.stock : stock.current.value ? stock.current.value : 100,

            "fabricType" : selectedValue, 

            "ocassion" : "",

      }
    if(edit && edit.type === 1){
      console.log("this is what is used : ", edit)
      
      // const docs = await collection.where("src", "==", edit["src"]).get()
      let ID = (await getDocOnCondition(collection, "id", edit["id"]))[0]
      console.log("ID:",ID, Data)
      await updateDoc(collection, ID, Data)
      await updateSuits(edit.id, Data["src"])
      updateStatus("Fabric Edited Successfully")
      setEdit(null)
      window.location.reload()
    } else {
      Data["id"] = (new Date()).getTime().toString()
      await addData(collection, null, Data)
      console.log(Data)
      updateStatus("Uploaded Successfully")
      window.location.reload()
    }
    
  }
    
  
  }

  

  useEffect(() => {
    if (edit && edit.type === 1) {
      setSelectedValue( (edit.fabricType === "Shirt")  ? "Shirt" : "Suiting");
    }
  }, [edit]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    console.log("Selected Value:", event.target.value);
  };

  const addOption = (label, options, setOptions, setValue, newValue) => {
    const normalizedValue = newValue.trim().toLowerCase();
    if (!normalizedValue) return false;
    if (!options.includes(normalizedValue)) {
      setOptions((prev) => [...prev, normalizedValue]);
    }
    setValue(normalizedValue);
    return true;
  };

  const redistributeComposition = (list) => {
    const lockedSum = list.filter((m) => m.locked).reduce((acc, m) => acc + (Number(m.percent) || 0), 0);
    const autos = list.filter((m) => !m.locked);
    const remaining = Math.max(0, 100 - lockedSum);

    if (autos.length === 0) return list;

    const base = Math.floor(remaining / autos.length);
    const rem = remaining - base * autos.length;

    let autoIdx = 0;
    return list.map((m) => {
      if (m.locked) return m;
      const extra = autoIdx < rem ? 1 : 0;
      autoIdx += 1;
      return { ...m, percent: base + extra };
    });
  };

  const toggleCompositionMaterial = (name) => {
    setComposition((prev) => {
      const exists = prev.find((m) => m.name.toLowerCase() === name.toLowerCase());
      let next;
      if (exists) {
        next = prev.filter((m) => m.name.toLowerCase() !== name.toLowerCase());
      } else {
        next = [...prev, { name, percent: 0, locked: false }];
      }
      return redistributeComposition(next);
    });
  };

  const handleCompositionPercentChange = (name, val) => {
    let num = parseInt(val, 10);
    if (Number.isNaN(num)) num = 0;
    if (num < 0) num = 0;
    if (num > 100) num = 100;

    setComposition((prev) => {
      const next = prev.map((m) =>
        m.name.toLowerCase() === name.toLowerCase()
          ? { ...m, percent: num, locked: true }
          : m
      );
      return redistributeComposition(next);
    });
  };

  const clearCompositionLock = (name) => {
    setComposition((prev) => {
      const next = prev.map((m) =>
        m.name.toLowerCase() === name.toLowerCase() ? { ...m, locked: false } : m
      );
      return redistributeComposition(next);
    });
  };

  const addCustomComposition = (value) => {
    const raw = (value || "").trim();
    if (!raw) return false;
    const normalized = raw
      .split(" ")
      .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : w))
      .join(" ");
    const already = compositionOptions.find((o) => o.toLowerCase() === normalized.toLowerCase());
    const finalName = already || normalized;
    if (!already) {
      setCompositionOptions((prev) => [...prev, finalName]);
    }
    setComposition((prev) => {
      if (prev.find((m) => m.name.toLowerCase() === finalName.toLowerCase())) return prev;
      const next = [...prev, { name: finalName, percent: 0, locked: false }];
      return redistributeComposition(next);
    });
    return true;
  };

  const compositionTotal = composition.reduce((acc, m) => acc + (Number(m.percent) || 0), 0);
  const compositionString = composition
    .filter((m) => (Number(m.percent) || 0) > 0)
    .map((m) => `${m.name} ${m.percent}%`)
    .join(", ");

  return (
    <div className="Fabric hori_center fabric-modern">
      {optionModal.open && (
        <div className="fabric-option-modal-backdrop">
          <div className="fabric-option-modal">
            <div className="fabric-option-modal-title">Add {optionModal.label}</div>
            <input
              className="fabric-option-modal-input"
              value={optionModal.value}
              onChange={(e) => setOptionModal((prev) => ({ ...prev, value: e.target.value }))}
              placeholder={`Enter ${optionModal.label}`}
            />
            <div className="fabric-option-modal-actions">
              <button
                type="button"
                className="fabric-option-modal-cancel"
                onClick={() => setOptionModal({ open: false, label: "", value: "" })}
              >
                Cancel
              </button>
              <button
                type="button"
                className="fabric-option-modal-save"
                onClick={() => {
                  let saved = false;
                  if (optionModal.label === "weave") {
                    saved = addOption("weave", weaveOptions, setWeaveOptions, setWeaveValue, optionModal.value);
                  } else if (optionModal.label === "pattern") {
                    saved = addOption("pattern", patternOptions, setPatternOptions, setPatternValue, optionModal.value);
                  } else if (optionModal.label === "width") {
                    saved = addOption("width", widthOptions, setWidthOptions, setWidthValue, optionModal.value);
                  } else if (optionModal.label === "composition") {
                    saved = addCustomComposition(optionModal.value);
                  }
                  if (saved) {
                    setOptionModal({ open: false, label: "", value: "" });
                  }
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {status && <div className="fabric-status"><b>{status}</b></div>

      }

      <h4>
        {edit && edit.type ===1 ? `Editing a Fabric : ${edit.name}` : "Adding a new Fabric"}
      </h4>
      <div className="fabric-type-toggle">
        <label className={`fabric-type-option ${selectedValue === "Suiting" ? "fabric-type-option-active" : ""}`}>
          <input
            type="radio"
            value="Suiting"
            checked={selectedValue === "Suiting"}
            onChange={handleChange}
          />
          Suiting
        </label>
        <label className={`fabric-type-option ${selectedValue === "Shirt" ? "fabric-type-option-active" : ""}`}>
          <input
            type="radio"
            value="Shirt"
            checked={selectedValue === "Shirt"}
            onChange={handleChange}
          />
          Shirting
        </label>
      </div>
      <div className='f-inputs'>
        <b>Name of Fabric  <label style={{"color":"red"}}>*</label> </b> <br/>
        <input placeholder={edit && edit.type === 1 ? `${edit.name}`:`Name`} ref={fabricName}  
        onChange={()=>{console.log(fabricName.current.value)}}
        />
      </div>
      <div className='f-inputs'>
        <b>Brand <label style={{"color":"red"}}>*</label> </b> <br/>
        <div className="fabric-custom-select" ref={brandDropdownRef}>
          <button
            type="button"
            className="fabric-custom-select-trigger"
            onClick={() => setBrandDropdownOpen((v) => !v)}
          >
            <span>{brandValue || "Select brand"}</span>
            <span className={`fabric-custom-select-arrow ${brandDropdownOpen ? "open" : ""}`}>▾</span>
          </button>
          {brandDropdownOpen && (
            <div className="fabric-custom-select-menu">
              {Brands && Brands.map((val) => (
                <button
                  type="button"
                  key={val.name}
                  className={`fabric-custom-select-option ${brandValue === val.name ? "active" : ""}`}
                  onClick={() => {
                    setBrandValue(val.name)
                    setBrandDropdownOpen(false)
                  }}
                >
                  {val.name}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* <div className='f-inputs'>
        <b>Ocassion <label style={{"color":"red"}}>*</label> </b> <br/>
        <select name="brands" id="brands"
          onChange={()=>{
            const b = document.getElementById("brands").value
            console.log( b )}}
        >
          {Brands && Brands.map((val, k)=>{
            return (<option value={val.name}>{val.name}</option>)
          })}
          
        </select>
      </div> */}
      
      <div className='f-inputs'>
        <b>Description of the Fabric <label style={{"color":"red"}}>*</label> </b> <br/>
        <textarea placeholder={edit && edit.type === 1 ? `${edit.des}`:`Description`} ref={des}
          onChange={()=>{console.log(des.current.value)}}
        />
      </div>
      <div className='f-inputs'>
        <b>Colours (comma-separated values) <label style={{"color":"red"}}>*</label> </b> <br/>
        <input placeholder={edit && edit.type === 1 ? `${edit.color}`:`Color`} ref={color} 
        
        onChange={()=>{console.log(color.current.value)}}
        />
      </div>
      <div className='f-inputs'>
        <b>Hex Codes for Colours (comma-separated values) <label style={{"color":"red"}}>*</label> </b> <br/>
        <input placeholder={edit && edit.type === 1 ? `${edit.colorCode}`:`Color Codes`} ref={colorCode}  
          onChange={()=>{console.log(colorCode.current.value)}}
        />
      </div>
      <div className='f-inputs'>
        <div className="fabric-label-row">
          <b>Weave </b>
          <button type="button" className="fabric-add-option-btn" onClick={() => setOptionModal({ open: true, label: "weave", value: "" })}>+</button>
        </div>
        <div className="fabric-custom-select" ref={weaveDropdownRef}>
          <button
            type="button"
            className="fabric-custom-select-trigger"
            onClick={() => setWeaveDropdownOpen((v) => !v)}
          >
            <span>{formatOptionLabel(weaveValue) || "Select weave"}</span>
            <span className={`fabric-custom-select-arrow ${weaveDropdownOpen ? "open" : ""}`}>▾</span>
          </button>
          {weaveDropdownOpen && (
            <div className="fabric-custom-select-menu">
              {weaveOptions.map((val) => (
                <button
                  type="button"
                  key={val}
                  className={`fabric-custom-select-option ${weaveValue === val ? "active" : ""}`}
                  onClick={() => {
                    setWeaveValue(val)
                    setWeaveDropdownOpen(false)
                  }}
                >
                  {formatOptionLabel(val)}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className='f-inputs'>
        <div className="fabric-label-row">
          <b>Composition </b>
          <button
            type="button"
            className="fabric-add-option-btn"
            onClick={() => setOptionModal({ open: true, label: "composition", value: "" })}
            aria-label="Add custom material"
          >
            +
          </button>
        </div>
        <div className="fabric-composition-grid">
          {compositionOptions.map((name) => {
            const entry = composition.find((m) => m.name.toLowerCase() === name.toLowerCase());
            const checked = Boolean(entry);
            return (
              <div
                key={name}
                className={`fabric-composition-row ${checked ? "fabric-composition-row-active" : ""}`}
              >
                <label className="fabric-composition-checkbox">
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => toggleCompositionMaterial(name)}
                  />
                  <span className="fabric-composition-tick" aria-hidden="true">
                    <svg width="12" height="12" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="4 10 8 14 16 6"></polyline>
                    </svg>
                  </span>
                  <span className="fabric-composition-name">{name}</span>
                </label>
                {checked && (
                  <div className={`fabric-composition-percent ${entry.locked ? "fabric-composition-percent-locked" : "fabric-composition-percent-auto"}`}>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      value={entry.percent}
                      onChange={(e) => handleCompositionPercentChange(name, e.target.value)}
                      aria-label={`${name} percentage`}
                    />
                    <span className="fabric-composition-percent-suffix">%</span>
                    {entry.locked && (
                      <button
                        type="button"
                        className="fabric-composition-unlock"
                        onClick={() => clearCompositionLock(name)}
                        title="Auto distribute this value"
                      >
                        Auto
                      </button>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className={`fabric-composition-total ${compositionTotal === 100 ? "fabric-composition-total-ok" : composition.length > 0 ? "fabric-composition-total-warn" : ""}`}>
          {composition.length > 0 ? (
            <>
              <span>Total:</span>
              <strong>{compositionTotal}%</strong>
              {compositionTotal !== 100 && <em> (should be 100%)</em>}
            </>
          ) : (
            <span className="fabric-composition-hint">Tick materials and enter %. Unticked auto-fills rest.</span>
          )}
        </div>
        <input type="hidden" ref={material} value={compositionString} readOnly />
      </div>
      <div className='f-inputs'>
        <div className="fabric-label-row">
          <b>Pattern </b>
          <button type="button" className="fabric-add-option-btn" onClick={() => setOptionModal({ open: true, label: "pattern", value: "" })}>+</button>
        </div>
        <div className="fabric-custom-select" ref={patternDropdownRef}>
          <button
            type="button"
            className="fabric-custom-select-trigger"
            onClick={() => setPatternDropdownOpen((v) => !v)}
          >
            <span>{formatOptionLabel(patternValue) || "Select pattern"}</span>
            <span className={`fabric-custom-select-arrow ${patternDropdownOpen ? "open" : ""}`}>▾</span>
          </button>
          {patternDropdownOpen && (
            <div className="fabric-custom-select-menu">
              {patternOptions.map((val) => (
                <button
                  type="button"
                  key={val}
                  className={`fabric-custom-select-option ${patternValue === val ? "active" : ""}`}
                  onClick={() => {
                    setPatternValue(val)
                    setPatternDropdownOpen(false)
                  }}
                >
                  {formatOptionLabel(val)}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className='f-inputs'>
        <div className="fabric-label-row">
          <b>Width  </b>
          <button type="button" className="fabric-add-option-btn" onClick={() => setOptionModal({ open: true, label: "width", value: "" })}>+</button>
        </div>
        <div className="fabric-custom-select" ref={widthDropdownRef}>
          <button
            type="button"
            className="fabric-custom-select-trigger"
            onClick={() => setWidthDropdownOpen((v) => !v)}
          >
            <span>{formatOptionLabel(widthValue) || "Select width"}</span>
            <span className={`fabric-custom-select-arrow ${widthDropdownOpen ? "open" : ""}`}>▾</span>
          </button>
          {widthDropdownOpen && (
            <div className="fabric-custom-select-menu">
              {widthOptions.map((val) => (
                <button
                  type="button"
                  key={val}
                  className={`fabric-custom-select-option ${widthValue === val ? "active" : ""}`}
                  onClick={() => {
                    setWidthValue(val)
                    setWidthDropdownOpen(false)
                  }}
                >
                  {formatOptionLabel(val)}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className='f-inputs'>
        <b>Weight  </b> <br/>
        <input placeholder={edit && edit.type === 1 ? `${edit.weight}`:`Weight`} ref={weight}  
        onChange={()=>{console.log(weight.current.value)}}
          />
      </div>
      
      {/* Disablling ocassion for now */}
      {/* <div className='f-inputs'>
        <b>Ocassion <label style={{"color":"red"}}>*</label> </b> <br/>
        <select name="ocassion" id="ocassion"
          onChange={()=>{
            const b = document.getElementById("ocassion").value
            console.log( b )}}
        >
          {oca && oca.map((val, k)=>{
            return (<option value={val}>{val}</option>)
          })}
          
        </select>
      </div> */}

      <div className='f-inputs'>
        <b>Link </b> <br/>
        <input placeholder={edit && edit.type === 1 ? `${edit.link}`:`Link`} ref={link}  
          onChange={()=>{console.log(link.current.value)}}
        />
      </div>

      <div className='f-inputs'>
        <b>Stock. By default 100 Meters</b> <br/>
        <input placeholder={edit && edit.type === 1 ? `${edit.stock}`:`Stock. Default : 100 meters`} ref={stock}  
          onChange={()=>{console.log(stock.current.value)}}
        />
      </div>
      
      
      
      {edit && edit.type === 1 && <div className="fabric-current-image">Current Image : <img src={edit.src} className="fabric-current-image-preview"/></div> }
      
      
      
      <h5 className="fabric-file-title">Main Fabric Image : <label style={{"color":"red"}}>*</label> </h5>
      <input className="fabric-file-input" placeholder='imgFile' onChange={(e)=>{setimgFile(e.target.files[0])}} type='file'/>
      
      {preview && <div className='f-p-d'>
        <>Uploaded File : <img src={preview} className='f-p-image' /></>
      </div>}
     

      <h5 className="fabric-file-title">Other Fabric Image : </h5>
      <input className="fabric-file-input" placeholder='otherFile' onChange={(e)=>{setOtherImg(e.target.files)}} type='file' multiple/>
      {otherPreview && 
      <div className="fabric-other-preview-scroll">
      <div className='f-p-d-wrapper'>
          {otherPreview.map((val, key)=>{
            return(
            <div className='f-p-d'>
              <img src={val} className='f-p-image' />
            </div>
            )
          })
          }
      </div>
      </div>
      }

      <button
        className='hori_center fabric-submit-btn'

        onClick={()=>{
          if(enable === 1){
            updateStatus("Uploading , Please Wait ...")
            submitFabric().then(()=>{
                console.log("complete")
              })
          }
          
        }}
      >
        {enable === 1 ? `Submit` : `Processing ...`}
      </button>

      

      

    </div>
  );
}

export default Fabric;
